import {
  GET_CATEGORIES,
  GET_CATEGORIES_FAIL,
  GET_CATEGORIES_SUCCESS,
  GET_CATEGORY_DETAILS,
  GET_CATEGORY_DETAILS_SUCCESS,
  GET_CATEGORY_DETAILS_FAIL,
  CREATE_CATEGORY,
  CREATE_CATEGORY_SUCCESS,
  CREATE_CATEGORY_FAIL,
  UPDATE_CATEGORY,
  UPDATE_CATEGORY_SUCCESS,
  UPDATE_CATEGORY_FAIL,
  DELETE_CATEGORY,
  DELETE_CATEGORY_SUCCESS,
  DELETE_CATEGORY_FAIL,
  GET_PRODUCT_BY_CATEGORY,
  GET_PRODUCT_BY_CATEGORY_SUCCESS,
  GET_PRODUCT_BY_CATEGORY_FAIL,
  GET_ALL_USER_CATEGORIES,
  GET_ALL_USER_CATEGORIES_SUCCESS,
  GET_ALL_USER_CATEGORIES_FAIL,
} from "./actionTypes"

//all categories
export const getCategories = (page, limit, searchText) => ({
  type: GET_CATEGORIES,
  payload: { page, limit, searchText },
})

//all categories
export const getCategoriesSuccess = categories => ({
  type: GET_CATEGORIES_SUCCESS,
  payload: categories,
})

export const getCategoriesFail = error => ({
  type: GET_CATEGORIES_FAIL,
  payload: error,
})

export const getCategoryDetails = categoryId => ({
  type: GET_CATEGORY_DETAILS,
  payload: categoryId,
})

export const getCategoryDetailsSuccess = categoryDetails => ({
  type: GET_CATEGORY_DETAILS_SUCCESS,
  payload: categoryDetails,
})

export const getCategoryDetailsFail = error => ({
  type: GET_CATEGORY_DETAILS_FAIL,
  payload: error,
})

export const createCategory = (category, history) => ({
  type: CREATE_CATEGORY,
  payload: { category, history },
})

export const createCategorySuccess = category => ({
  type: CREATE_CATEGORY_SUCCESS,
  payload: category,
})

export const createCategoryFail = error => ({
  type: CREATE_CATEGORY_FAIL,
  payload: error,
})

export const updateCategory = (category, categoryId, history) => ({
  type: UPDATE_CATEGORY,
  payload: { category, categoryId, history },
})

export const updateCategorySuccess = category => ({
  type: UPDATE_CATEGORY_SUCCESS,
  payload: category,
})

export const updateCategoryFail = error => ({
  type: UPDATE_CATEGORY_FAIL,
  payload: error,
})

export const deleteCategory = (categoryId, history) => ({
  type: DELETE_CATEGORY,
  categoryId,
  history,
})

export const deleteCategorySuccess = category => ({
  type: DELETE_CATEGORY_SUCCESS,
  payload: category,
})

export const deleteCategoryFail = error => ({
  type: DELETE_CATEGORY_FAIL,
  payload: error,
})

export const getProductsByCategory = options => ({
  type: GET_PRODUCT_BY_CATEGORY,
  payload: options,
})

export const getProductsByCategorySuccess = products => (
  console.log(products),
  {
    type: GET_PRODUCT_BY_CATEGORY_SUCCESS,
    payload: products,
  }
)
export const getProductsByCategoryFail = error => ({
  type: GET_PRODUCT_BY_CATEGORY_FAIL,
  payload: error,
})

export const getAllUserCategories = (page, type, limit, listAll) => ({
  type: GET_ALL_USER_CATEGORIES,
  payload: { page, type, limit, listAll },
})

export const getAllUserCategoriesSuccess = category => ({
  type: GET_ALL_USER_CATEGORIES_SUCCESS,
  payload: category,
})
export const getAllUserCategoriesFail = error => ({
  type: GET_ALL_USER_CATEGORIES_FAIL,
  payload: error,
})
